import moment from "moment";

import { CreateAnnouncementRequestBody } from "../apis";
import { AnnouncementFormValues } from "../components";

export const convertAnnouncementFormDataToCreateRequestBody = (
  formData: AnnouncementFormValues
): CreateAnnouncementRequestBody => {
  const postingDate =
    formData.shownToResellersUntilDate && formData.shownToResellersUntilTime
      ? moment(formData.shownToResellersUntilDate)
          .set({
            hour: parseInt(formData.shownToResellersUntilTime.split(":")[0]),
            minute: parseInt(formData.shownToResellersUntilTime.split(":")[1]),
            second: parseInt(formData.shownToResellersUntilTime.split(":")[2])
          })
          .toISOString()
      : "";

  return {
    imageId: formData.image?.id ?? "",
    title: formData.title,
    text: formData.text,
    shownToResellersUntil: postingDate
  };
};
